module.exports = __webpack_public_path__ + "static/img/crop.ea99e1ab.svg";